import { render } from "./IPForm.vue?vue&type=template&id=016783c3"
import script from "./IPForm.vue?vue&type=script&lang=js"
export * from "./IPForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__